import { render, staticRenderFns } from "./menuSelector.vue?vue&type=template&id=88d5c586&"
import script from "./menuSelector.vue?vue&type=script&lang=ts&"
export * from "./menuSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports